<template lang="pug">
  #cookie-policy(v-if="isShow")
    p 我們的網站使用信義房屋及我們合作夥伴的 Cookie 來提升您的使用者體驗，這些資訊有助於我們顯示更符合您興趣的廣告。繼續瀏覽網站即表示您同意我們的#[a(href="https://www.sinyi.com.tw/privacy" target="_blank") 隱私權政策]與資料使用。
    a(href="#" @click.prevent="agree") 同 意
</template>

<script>
export default {
  name: 'CookiePolicy',
  props: {
  },
  data: () => {
    return {
      isShow: false,
    }
  },
  computed: {
  },
  methods: {
    agree() {
      localStorage.setItem('agreePolicy', true);
      this.isShow = false;
    }
  },
  mounted() {
    if (!localStorage.getItem('agreePolicy')) {
      this.isShow = true
    }
  }
}
</script>

<style lang="scss" scoped>

#cookie-policy {

  position: fixed;
  bottom: vwXL(11);
  right: vwXL(15);
  width: vwXL(728);
  padding: vwXL(22) vwXL(10) vwXL(31) vwXL(30);
  background: rgba(#005323, 0.8);
  z-index: 10;

  @include tablet {
    bottom: vw(10);
    right: auto;
    left: vw(10);
    width: calc(100% - vw(20));
    padding: vw(23) vw(29) vw(71);
  }

  p {
    color: #fff;
    font-size: vwXL(22);
    font-weight: 500;
    text-align: justify;
    line-height: lineHeight(22, 41);
    transform: scaleX(.95);
    @include tablet {
      font-size: vw(22);
      transform: none;
    }
    a {
      color: #fff;
      border-bottom: #fff 1px solid;
      // text-decoration: underline;
    }
  }

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: vwXL(30);
    bottom: vwXL(22);
    width: vwXL(202);
    height: vwXL(40);
    color: #005323;
    font-size: vwXL(28);
    // text-align: center;
    padding-bottom: vwXL(3);
    border-radius: vwXL(40);
    word-spacing: vwXL(46);
    background: #fff;
    @include tablet {
      right: vw(30);
      bottom: vw(22);
      width: vw(202);
      height: vw(40);
      font-size: vw(28);
      padding-bottom: vw(3);
      border-radius: vw(40);
      word-spacing: vw(44);
    }
  }

}

</style>
